export default "__VITE_ASSET__1fa94c7d__"